<template lang="pug">
.cp-aiCallbot
  .page1
    .wrap.procuct-header
      .left-wrap
        p 去电反诈劝阻机器人
        p 为了提高反诈劝阻的及时性、有效性及劝阻成功率，去电人工智能针对性研发出反诈劝阻机器人
    product-list2(:config="productListConfig")
  content-list(:list="list")
  .w
    img(src="../../assets/fz-6.png",style="width: 100%")
  apply-list(:info="applyInfo", :img="applyImg",  @showModal="showModal")
  page-belt(:beltType="1" @showModal="showModal")
</template>
<script>
import productList2 from './components/product-list2'
import contentList from './components/content-list'
import applyList from './components/apply-list'

export default {
  components: {
    productList2,
    contentList,
    applyList,
  },
  props: {},
  data () {
    return {
      productListConfig: {
        img: 'fz-1.png',
        list: [
          { iconClass: 'iconzhinengduihua', label: '快速干预', content: '在预警数据产生的第一时间即可全自动对潜在受害人拨打劝阻电话' },
          { iconClass: 'iconfunengqiyeyingyong', label: '及时阻断', content: '通过机器人劝阻及判断潜在被害人的受骗状态来达到成劝阻目的，挽回潜在受害人损失' },
          { iconClass: 'iconfangsaorao', label: '精准劝阻', content: '针对性提高高危线家的劝阻深度，增加劝阻有效性' },
          { iconClass: 'iconbianjiejieru', label: '流程自动化', content: '根据不同预警数据源自动执行流转，数据下发、劝阻、记录、上报' },
        ]
      },
      list: [
        { title: '实时处理', content: '潜在涉诈线索实时推送立即拨打，以最快速度保卫人民财产安全', labels: ['实时推送', '立即拨打', '节省警力'], imgSrc: require('@/assets/fz-2.png'), imgStyle: { width: '471px' } },
        { title: '实时记录', content: '挂机后即可生成对话记录，数据可视化强', labels: ['记录生成', '及时汇总', '全节点数据可视化'], imgSrc: require('@/assets/fz-3.png'), imgStyle: { width: '493px' } },
        { title: '数据分类', content: '根据案件类型定义不同跟进记录表单，针对不同案件情景，采用不同联络话术', labels: ['跟进节点', '跟进状态', '分批处理'], imgSrc: require('@/assets/fz-4.png'), imgStyle: { width: '565px' } },
        { title: '智能引导倾诉', content: '机器人可基于情感、语言环境等维度智能对答', labels: ['拟真性高', '接近真人', '智能对答'], imgSrc: require('@/assets/fz-5.png'), imgStyle: { width: '448px' } },
      ],
      applyInfo: {
        titles: ['反诈宣传', '反诈调研', '满意度测评'],
        content: '近年电信网络诈骗案件频发，隐蔽性、随机性、突发性是其主要特点。反诈劝阻机器人通过96110号码接入，在预警数据产生的第一时间即可全自动对潜在受害人拨打劝阻电话，通过机器人劝阻及判断潜在被害人的受骗状态来达到成劝阻目的，挽回潜在受害人损失。'
      },
      applyImg: { src: require('../../assets/fz-7.png'), style: 'width: 524px' },
    }
  },
  computed: {},
  methods: {
    showModal () {
      this.$emit('showModal', true)
    }
  }
}
</script>
<style lang="stylus">
@import './config'
.cp-aiCallbot
  .page1
    padding-top $topbar-height
    background #0a1e50
    .procuct-header
      height 580px
      background: url("../../assets/fz-banner.png") center no-repeat
      background-size: cover;
      margin-bottom -121px
      margin-top -94px
    .wrap
      position relative
      .left-wrap
        position absolute
        padding-top 178px
        left 20%
        width 389px
        p
          &:first-child
            font-size 36px
            margin-bottom 15px
          &:nth-child(2)
            font-size 16px
            color #D5DCEC
        .banner-btn
          margin-top 38px
    .banner-wrap
      position relative
</style>
